import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import API from './../../api'
import Slider from 'react-slick'
import PriceConverter from '../helpers/PriceConverter'
import PromotionLabel from '../helpers/PromotionLabel'
import TwoDatesFormat from '../helpers/TwoDatesFormat'

export default function SpecialDeals() {
  const [deals, setDeals] = useState([])
  useEffect(function() {
    API(`promotions/best-deals/`).get().then(({ results }) => {
      setDeals(results)
    })
  }, [])

  const settings = {
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    dots: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 769, settings: { slidesToShow: 2.5, slidesToScroll: 1, arrows: false } },
      { breakpoint: 481, settings: { slidesToShow: 1.2, slidesToScroll: 1, arrows: false } },
    ],
  }
  return (
    <Slider className='slick-pt-custom space-between same-height' {...settings}>
      {
        deals.map((shop) => {
          return (
            <div className='operator-item-wrapper' key={shop.url}>
              <a className='operator-item-card bordered-element' href={shop.url} target='_blank'>
                <div className='img-wrapper'>
                  <span style={{ backgroundImage: `url(${shop.backgrounds.DOSliderMobileLand})` }} className='img' />
                </div>

                <div className='info'>
                  <strong className='shop-title' >{ shop.shopTitle }</strong>
                  <ul className='features'>
                    <li>
                      <i className='font-icons location-icon' />
                      { shop.areaTitle }, { shop.countryTitle }
                    </li>
                    <li>
                      <i className='font-icons dive-center-icon' />
                      {shop.numberOfDivesMax ? (
                        <FormattedMessage
                          id='including_dives_min_max'
                          defaultMessage='Including { divesMin } - { divesMax } dives'
                          values={
                            {
                              divesMin: shop.numberOfDivesMin,
                              divesMax: shop.numberOfDivesMax,
                            }
                          }
                        />
                      ) : (
                        <FormattedMessage
                          id='including_dives_min'
                          defaultMessage='Including { divesMin } dives'
                          values={
                            {
                              divesMin: shop.numberOfDivesMin,
                            }
                          }
                        />
                      )
                      }
                    </li>
                    <li>
                      <i className='font-icons calendar-icon' />
                      <TwoDatesFormat dateFrom={shop.dateFrom} dateTo={shop.dateTo} />
                    </li>
                  </ul>
                </div>
                {
                  shop.availableSpots ? (
                    <div className='price-wrap'>
                      <PromotionLabel promotion={shop.promotion} currency={shop.currency} price={shop.price} compareAtPrice={shop.compareAtPrice} showComparePrice />
                      <span className='price'><PriceConverter amount={shop.price} currency={shop.currency} /></span>
                      <div className='price-details'>
                        <span className='price-type'><FormattedMessage id='per_person_for_nights'
                          values={{
                            duration: shop.duration,
                          }}
                          defaultMessage='per person for { duration } nights' /></span>
                        { shop.availableSpots < 5 ? (
                          <span className='spots-left'>
                            <FormattedMessage id='spots_left_only' values={{
                                  qty: shop.availableSpots,
                                }} defaultMessage='Only { qty } left' />
                          </span>
                        ) : '' }
                      </div>
                    </div>
                  ) : (
                    <div className='price-wrap'>
                      <div className='sold-out'>
                        <i className='font-icons fail-icon-new' /> <FormattedMessage id='sold-out' defaultMessage='Sold out' />
                      </div>
                    </div>
                  )
                }
                
              </a>
            </div>
          )
        })
      }
    </Slider>
  )
}
